


















































































































































import PageLoader from '@components/common/PageLoader.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PageLoader,
  },
})
export default class PopupSortPlan extends Vue {
  public menu: any = null;
  public tempSelectedPlans: any[] = [];
  public filteredPlans: any[] | null = null;
  public planSearchString: string = '';
  public isLoading: boolean = false;

  get activePlanList() {
    if (this.filteredPlans !== null) {
      return this.filteredPlans;
    }
    return this.menu?.plans || [];
  }

  get tempSelectedPlanIds() {
    return this.tempSelectedPlans.map((menu) => menu.id);
  }

  beforeOpen({ params: { menu, selectedPlans } }) {
    this.planSearchString = '';
    this.menu = menu;
    this.tempSelectedPlans = [...selectedPlans];
    this.filteredPlans = null;
  }

  handleClickPlanCheckbox(event, plan) {
    if (event.target.checked) {
      const planDto = {
        id: plan.id,
        order: this.tempSelectedPlans.length + 1,
        display: true,
        name: plan.name,
      };
      this.tempSelectedPlans.push(planDto);
    } else {
      this.tempSelectedPlans = this.tempSelectedPlans.filter(
        (i) => i.id !== plan.id,
      );
    }
  }

  searchByName() {
    this.isLoading = true;
    if (!this.planSearchString) {
      this.filteredPlans = null;
    } else {
      this.filteredPlans = this.menu.plans.filter((menu) =>
        menu.name.toLowerCase().includes(this.planSearchString.toLowerCase()),
      );
    }
    this.isLoading = false;
  }

  handleChangePlanOrder(oldIndex, index) {
    const movedplan = this.tempSelectedPlans.splice(oldIndex, 1);
    this.tempSelectedPlans.splice(index - 1, 0, ...movedplan);
  }

  get allSelected(): boolean {
    return this.activePlanList.every((plan) =>
      this.tempSelectedPlanIds.includes(plan.id),
    );
  }

  handleToggleActiveAllPlanOrder() {
    if (this.allSelected) {
      const activeIds = this.activePlanList.map((plan) => plan.id);
      this.tempSelectedPlans = this.tempSelectedPlans.filter(
        (plan) => !activeIds.includes(plan.id),
      );
    } else {

      const existingIds = this.tempSelectedPlanIds;
      const newPlans = this.activePlanList
        .filter((plan) => !existingIds.includes(plan.id))
        .map((plan, index) => ({
          id: plan.id,
          order: this.tempSelectedPlans.length + index + 1,
          display: true,
          name: plan.name,
        }));

      this.tempSelectedPlans.push(...newPlans);
    }

    this.tempSelectedPlans = this.tempSelectedPlans.map((plan, index) => ({
      ...plan,
      order: index + 1,
    }));
  }

  submit() {
    this.$emit('submit', {
      menuId: this.menu.id,
      plans: this.tempSelectedPlans,
    });
    this.$modal.hide('popup-sort-plan');
  }

  cancel() {
    this.$modal.hide('popup-sort-plan');
  }
}
